import * as z from "zod/v4";

export const createPurchaseOrderViewFolder = {
  name: "createPurchaseOrderViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
